<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="상담 내용" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <c-btn v-if="updateMode && editable" label="서명" icon="auto_fix_normal" @btnClicked="signatureConsult" />
                <c-btn v-if="updateMode && editable" label="삭제" icon="remove" @btnClicked="removeConsult" />
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveConsult"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  v-if="isSuspect"
                  label="대상자"
                  :editable="editable"
                  :disabled="true"
                  name="suspectUserName"
                  v-model="popupParam.suspectUserName">
                </c-text>
                <c-field
                  v-else
                  :editable="editable"
                  :data="data"
                  deptValue="normalDeptCd"
                  type="dept_user"
                  label="대상자"
                  name="normalUserId"
                  v-model="data.normalUserId">
                </c-field>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-select
                  required
                  codeGroupCd="SUSPECT_CONSULT_TYPE_CD"
                  type="edit"
                  :editable="editable"
                  itemText="codeName"
                  itemValue="code"
                  name="consultTypeCd"
                  label="상담구분"
                  v-model="data.consultTypeCd"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-datepicker
                  required
                  :editable="editable"
                  default="today"
                  label="상담일"
                  name="consultDate"
                  v-model="data.consultDate"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  label="상담간호사"
                  name="counselorName"
                  v-model="data.counselorName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <c-text
                  required
                  :editable="editable"
                  label="상담내용"
                  name="consultContent"
                  v-model="data.consultContent">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  label="증상"
                  :editable="editable"
                  name="symptom"
                  :rows="3"
                  v-model="data.symptom">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  label="과거력"
                  :editable="editable"
                  name="diseasePast"
                  :rows="3"
                  v-model="data.diseasePast">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  label="현 병력"
                  :editable="editable"
                  :rows="3"
                  name="diseaseCurrent"
                  v-model="data.diseaseCurrent">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  label="상담결과 및 특이사항"
                  :editable="editable"
                  :rows="3"
                  name="remark"
                  v-model="data.remark">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="측정" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-3">
                <c-text
                  suffix="mg/dL"
                  label="혈당"
                  :editable="editable"
                  name="bidSugValue"
                  v-model="data.bidSugValue">
                </c-text>
              </div>
              <div class="col-3">
                <c-text
                  suffix="mg/dL"
                  label="콜레스테롤"
                  :editable="editable"
                  name="cholesterolValue"
                  v-model="data.cholesterolValue">
                </c-text>
              </div>
              <div class="col-3">
                <c-text
                  suffix="mmHg"
                  label="혈압-수축기"
                  :editable="editable"
                  name="bidPressContValue"
                  v-model="data.bidPressContValue">
                </c-text>
              </div>
              <div class="col-3">
                <c-text
                  suffix="mmHg"
                  label="혈압-이완기"
                  type="number"
                  :editable="editable"
                  name="bidPressReleValue"
                  v-model="data.bidPressReleValue">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-top: 20px !important;">
          <c-upload 
            :attachInfo="attachInfo"
            :editable="editable">
          </c-upload>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'consult-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        suspectConsultId: '',
        suspectId: '',
        suspectUserName: '',
        suspectFlag: '',
      }),
    },
  },
  data() {
    return {
      editable: false,
      data: {
        suspectConsultId: '',
        suspectId: '',
        consultContent: '',
        consultDate: '',
        diseasePast: '',
        diseaseCurrent: '',
        symptom: '',
        remark: '',
        consultTypeCd: null,
        counselorName: '',
        bidSugValue: '',
        cholesterolValue: '',
        bidPressContValue: '',
        bidPressReleValue: '',
        electronSignature: '',
        normalUserId: '',
        normalDeptCd: '',
        suspectFlag: 'N',
        regUserId: '',
        chgUserId: '',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'CONSULT_HISTORY',
        taskKey: '',
      },
      updateMode: false,
      getUrl: '',
      saveUrl: 'transactionConfig.hea.checkup.suspect.consult.insert.url;',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      isSave: false,
      mappingType: 'POST',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    isSuspect() {
      return this.popupParam.suspectFlag === 'Y'
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.getUrl = selectConfig.hea.checkup.suspect.consult.get.url;
      this.insertUrl = transactionConfig.hea.checkup.suspect.consult.insert.url;
      this.updateUrl = transactionConfig.hea.checkup.suspect.consult.update.url;
      this.deleteUrl = transactionConfig.hea.checkup.suspect.consult.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.suspectConsultId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.suspectConsultId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.data, _result.data)
          this.updateMode = true;
          this.$set(this.attachInfo, 'taskKey', this.popupParam.suspectConsultId)

        },);
      } else {
        this.$set(this.data, 'suspectFlag', this.popupParam.suspectFlag)
      }
    },
    saveConsult() {
      if (this.popupParam.suspectConsultId) {
        this.mappingType = 'PUT';
        this.saveUrl = this.updateUrl;
      } else {
        this.mappingType = 'POST';
        this.saveUrl = this.insertUrl;
        this.data.suspectId = this.popupParam.suspectId
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
           window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.userId;
              this.data.chgUserId = this.$store.getters.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
     
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.suspectConsultId = result.data
      this.$set(this.attachInfo, 'taskKey', result.data)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.getDetail();
    },
    removeConsult() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.suspectConsultId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          })
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    signatureConsult() {
      this.popupOptions.target = () => import(`${"./consultSignaturePop.vue"}`);
      this.popupOptions.title = '이름을 정자로 입력하세요.';
      this.popupOptions.isFull = false;
      this.popupOptions.width = '470px';
      this.popupOptions.param = {
        suspectConsultId: this.popupParam.suspectConsultId,
        electronSignature: this.data.electronSignature,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getDetail();
    },
  }
};
</script>